<template>
  <div class="count-down" :class="cssType + ' ' + locale" v-if="realTime > 0">
    <div class="count-down-title">{{ text }}</div>
    <div class="count-down-time">
      <span class="box" v-if="countDown.day > 0">
        {{ countDown.day }} {{ $t('sf.day') }}
      </span>
      <span class="box">
        {{ countDown.hour }}
      </span>
      <span>:</span>
      <span class="box">
        {{ countDown.minute }}
      </span>
      <span>:</span>
      <span class="box">
        {{ countDown.second }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed, reactive, watch, defineEmits } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
// const now = Date.now()
const emit = defineEmits(['end'])
const props = defineProps({
  realTime: {
    type: Number,
    default: 0,
  },
})

const state = reactive({
  // activeStartTime: now + 3 * 1000,
  // activeEndTime: now + 6 * 1000,
  // rewardEndTime: now + 9 * 1000
  activeStartTime: 1777395600000,
  activeEndTime: 1779037199000,
  rewardEndTime: 1779641999000
})

const type = computed(() => {
  if (props.realTime < state.activeStartTime) {
    return 'beforeActive'
  }
  if (props.realTime >= state.activeStartTime && props.realTime < state.activeEndTime) {
    return 'activing'
  }
  if (props.realTime >= state.activeEndTime && props.realTime < state.rewardEndTime) {
    return 'rewarding'
  }
  return 'end'
})

watch(type, (newVal) => {
  if (newVal === 'end') {
    emit('end')
  }
})

const text = computed(() => {
  if (type.value === 'beforeActive') {
    return t('accum.actStartCountDown')
  }
  if (type.value === 'activing') {
    return t('accum.actEndCountDown')
  }
  if (type.value === 'rewarding') {
    return t('accum.rewardEndCountDown')
  }
  return t('accum.actEnded')
})
const countDown = computed(() => {
  let diff = 0
  if (type.value === 'beforeActive') {
    diff = Math.max(0, state.activeStartTime - props.realTime)
  }
  if (type.value === 'activing') {
    diff = Math.max(0, state.activeEndTime - props.realTime)
  }
  if (type.value === 'rewarding') {
    diff = Math.max(0, state.rewardEndTime - props.realTime)
  }
  const day = Math.floor(diff / 1000 / 60 / 60 / 24).toString().padStart(2, '0')
  const hour = Math.floor(diff / 1000 / 60 / 60 - day * 24).toString().padStart(2, '0')
  const minute = Math.floor(diff / 1000 / 60 - day * 24 * 60 - hour * 60).toString().padStart(2, '0')
  const second = Math.floor(diff / 1000 - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60).toString().padStart(2, '0')
  return {
    day,
    hour,
    minute,
    second,
  }
  // const hour = Math.floor(diff / 1000 / 60 / 60).toString().padStart(2, '0')
  // const minute = Math.floor(diff / 1000 / 60 - hour * 60).toString().padStart(2, '0')
  // const second = Math.floor(diff / 1000 - hour * 60 * 60 - minute * 60).toString().padStart(2, '0')
  // return {
  //   hour,
  //   minute,
  //   second,
  // }
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
